import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

import { DateTime } from 'luxon';
import { TvoedSalaryService, TvoedLabourAgreement } from '@metallgehalt/tvoed-salary-calculator';

import { TimeFrameStatus } from '../../enums/time-frame-status.model';

@Component({
  selector: 'tvoed-overview',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss'
})
export class OverviewComponent implements OnInit {
  salaryService = inject(TvoedSalaryService);
  titleService = inject(Title);
  metaService = inject(Meta);

  labourAgreements: (TvoedLabourAgreement & { status: TimeFrameStatus })[] = [];
  TimeFrameStatus = TimeFrameStatus;

  ngOnInit() {
    this.titleService.setTitle('Änderungen in der TVöD Entgelttabelle');
    this.metaService.updateTag({
      name: 'description',
      content: 'TVöD Entgelttabelle: Alle Tarifänderungen im öffentlichen Dienst – VKA, Bund, SuE, Pflege'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'TVöD, Tarifvertrag öffentlicher Dienst, Entgelttabelle, TVöD VKA, TVöD Bund, TVöD SuE, TVöD Pflege, Gehaltstabelle, Tarifänderung, öffentlicher Dienst'
    });
    this.salaryService.getLabourAgreements().subscribe(la => {
      this.labourAgreements = la
        .sort((a: TvoedLabourAgreement, b: TvoedLabourAgreement) => b.tvoed - a.tvoed)
        .map((la: TvoedLabourAgreement) => ({ ...la, status: this.checkTimeframeLuxon(la.validFrom, la.validTo) }));
    });
  }

  checkTimeframeLuxon(validFrom: string, validTo: string): TimeFrameStatus {
    const now = DateTime.local().startOf('day');
    const from = DateTime.fromISO(validFrom).startOf('day');
    const to = DateTime.fromISO(validTo).startOf('day');

    if (now < from) {
      return TimeFrameStatus.UPCOMING;
    } else if (now > to) {
      return TimeFrameStatus.PAST;
    } else {
      return TimeFrameStatus.WITHIN;
    }
  }
}
